module.exports = __webpack_public_path__ + "static/media/back.22405d80.png";